import React from 'react';

import { AppLayout } from '@amzn/awsui-components-react';
import Content from './Content';

class App extends React.Component {
  render() {
    return (
      <>
        <AppLayout
          content={<Content />}
          //contentType="no-paddings"
          disableContentPaddings={true}
          //contentType="default"
          navigationHide={true}
          toolsHide={true}
        />
      </>
    );
  }
}

export default App;
